import {useDocument} from '../../firebase/hooks/useDocument';
import {Collection, UserDocument} from '../UserDocument';
import {User} from '#common/users/types';

export function useUserDocument(id: string): UserDocument {
  return useDocument<User>(Collection, id);
}
